<template>
  <screener-frame>
    <screener-title title="Summary of Results" />
    <p class="body-2">
      Please choose from the options below.<br>
      You may view the patient results, finish this screener and
      allow a new patient to be screened, or request a Home Sleep Test
      for the patient by clicking the buttons below.
    </p>

    <screener-result-img
      :title="'Risk level - ' + riskLevel"
      :level="riskLevel"
    />

    <template #actions>
      <screener-result-btn />
      <v-spacer />
      <screener-restart-btn />
    </template>
  </screener-frame>
</template>

<script>
import { riskLevel } from '@/use/screener'

export default {
  setup: () => ({ riskLevel })
}
</script>
